import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";
import apiSafibc from "../../../axios/axios";
import { useLoginStore } from '../../../store/zustend';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";


const RegistrarPrestamo = () => {

    const { loginStore } = useLoginStore()

    const [catClientes, setCatClientes] = useState([])
    const [cliente, setCliente] = useState(null)
    const [spRA, setSpRA] = useState(false)
    const [cantidadPrestamo, setCantidadPrestamo] = useState(0)
    const [cantidadPrestamoFormateado, setCantidadPrestamoFormateado] = useState(0)
    const [fechaPrestamo, setFechaPrestamo] = useState('')
    const [fechaPrimerPago, setPrimerPago] = useState('')
    const [catTipoPrestamo, setCatTipoPrestamo] = useState([])
    const [tipoPrestamo, setTipoPrestamo] = useState('')
    const [folioPagare, setFolioPagare] = useState()
    const [intereses, setIntereses] = useState(10)
    const [cantidadAbonos, setCantidadAbonos] = useState('')
    const [imgPagare, setImgPagare] = useState('')



    const obtenerCatRegPrestamo = () => {

        const obtenerCats = async () => {

            try {

                const catalogos = await apiSafibc('/registrar-prestamo/catalogos', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                console.log(catalogos)
                setCatClientes(catalogos.data.clientes)
                setCatTipoPrestamo(catalogos.data.tipo_prestamos)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al registrar cliente, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setSpRA(false)
            }

        }

        obtenerCats()
    }


    useEffect(() => {
        obtenerCatRegPrestamo()
    }, [])

    const enviarFormulario = () => {
        console.log(cantidadPrestamo)
        if (!folioPagare) return toast.error('Agregar folio del pagare es obligatorio', toast_config)
        if (!imgPagare) return toast.error('Es necesario agregar imagen del pagare!', toast_config)
        if (!cliente) return toast.error('Seleccionar cliente es obligatorio', toast_config)
        if (!tipoPrestamo) return toast.error('Seleccionar tipo de prestamo es obligatorio', toast_config)
        if (cantidadPrestamo < 1000) return toast.error('El monto minimo del prestamo es de $ 1,000.00', toast_config)
        if (!cantidadAbonos) return toast.error('Es necesario agregar la cantidad de duración del prestamo!', toast_config)
        if (!fechaPrestamo) return toast.error('Es necesario agregar la fecha del prestamo!', toast_config)
        if (!fechaPrimerPago) return toast.error('Es necesario agregar la fecha del primero pago!', toast_config)
        if (!intereses) return toast.error('Es necesario agregar un interes!', toast_config)


        Swal.fire({
            title: "Esta seguro?",
            text: "Se va a crear prestamo!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, crear!"
        }).then(async (result) => {

            const formDataPrestamo = new FormData();
            formDataPrestamo.append("file", imgPagare); // importante: "file" debe coincidir con multer
            formDataPrestamo.append("folioPagare", folioPagare);
            formDataPrestamo.append("cliente", cliente);
            formDataPrestamo.append("tipoPrestamo", tipoPrestamo);
            formDataPrestamo.append("cantidadPrestamo", cantidadPrestamo);
            formDataPrestamo.append("cantidadAbonos", cantidadAbonos);
            formDataPrestamo.append("fechaPrestamo", fechaPrestamo);
            formDataPrestamo.append("fechaPrimerPago", fechaPrimerPago);
            formDataPrestamo.append("intereses", intereses);



            const guardando_prestamo = await apiSafibc.post('/registrar-prestamo/guardar', formDataPrestamo, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`,
                }
            })

            setSpRA(false)

            Swal.fire({
                icon: 'success',
                title: 'Enhorabuena!',
                text: guardando_prestamo.data.mensaje
            }).then(r => {
                window.location.href = 'registrar-prestamo'
            })


        }).catch((error) => {
            console.log(error)
            let msg_error = ''
            if (error.response) {
                if (error.response.data.error) {
                    msg_error = error.response.data.error
                } else {
                    msg_error = 'Ocurrió un error al agregar contrato, favor de volver a intentar!'
                }
            }
            setSpRA(false)
            //mensaje de toastify
            toast.error(msg_error, toast_config)
        });



    }


    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const formateoCantidad = (e) => {

        const input = e.target.value;

        const cleaned = input.replace(/,/g, '').replace(/[^\d.]/g, '');

        const parts = cleaned.split('.');
        if (parts.length > 2) return;

        // Guardar como número
        const numero = parseFloat(cleaned);

        const formateado = formatNumber(cleaned);


        setCantidadPrestamo(isNaN(numero) ? 0 : numero)
        setCantidadPrestamoFormateado(isNaN(numero) ? 0 : formateado)


    }

    const handleImage = async(e) => {
        const file = e.target.files[0];
        if (!file) return;

        // validar tipo
        if (!file.type.startsWith("image/")) {
            toast.error("El archivo debe ser una imagen", toast_config);
            return;
        }

        // validar tamaño original
        if (file.size > 1 * 1024 * 1024) {
            toast.error("La imagen no debe exceder 1MB", toast_config);
            return;
        }

        try {

            const compressedFile = await imageCompression(file, {
                maxSizeMB: 0.4,          // Máximo 400 KB
                maxWidthOrHeight: 1500,  // Redimensiona si es necesario
                initialQuality: 0.8,
                useWebWorker: true
            });

            if (compressedFile.size > 500 * 1024) {
                toast.error("No fue posible reducir suficientemente la imagen", toast_config);
                return;
            }

            setImgPagare(compressedFile)

        } catch (error) {
            console.error(error);
            toast.error("No fue posible procesar la imagen", toast_config);
        }

        

        /*const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onloadend = () => {
            setImgPagare(reader.result); // aquí tienes el base64
        };*/
    };

    return (
        <div className="container animation pt-5">
            <div className='row d-flex justify-content-center'>
                <div className='col-md-6'>
                    <div className='card shadow'>
                        <div className='card-body'>
                            <h3>Registrar Prestamo</h3>
                            <hr />
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <TextField onChange={(e) => setFolioPagare(e.target.value)} value={folioPagare} name='folio' className="mb-2" label="Folio Pagare" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                                <div className='col-md-6 mb-3'>
                                    <TextField onChange={handleImage} type="file" accept="image/*" className="mb-2" label="Img Pagare" variant="standard" style={{ 'width': '95%' }} />

                                </div>
                                <div className="col-md-6 mb-3">
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>

                                        <Autocomplete
                                            disablePortal
                                            options={catClientes.map((c) => ({ id: c.id_cliente, label: `${c.nombre} ${c.paterno} ${c.materno}` }))}
                                            onChange={(event, c) => {
                                                if (!c) return
                                                setCliente(c.id)
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Cliente" variant='standard' />}
                                        />


                                    </FormControl>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>
                                        <InputLabel id="standard-label">Tipo de Prestamo</InputLabel>
                                        <Select
                                            labelId="standard-label"
                                            id="select-standard"
                                            value={tipoPrestamo}
                                            onChange={(e) => setTipoPrestamo(e.target.value)}
                                            label="Tipo de Ahorro"
                                        >
                                            {catTipoPrestamo && catTipoPrestamo.map(tp => (
                                                <MenuItem value={tp.id_tipo_prestamo} key={tp.id_tipo_prestamo}>{`${tp.tipo_prestamo}`}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className='col-md-6 mb-5'>
                                    <TextField onChange={formateoCantidad} value={cantidadPrestamoFormateado} type='text' id="standard-basic" style={{ 'width': '100%' }} label="Cantidad a Prestar" variant="standard" />
                                </div>
                                <div className='col-md-6 mb-5'>
                                    <TextField onChange={(e) => setCantidadAbonos(e.target.value)} value={cantidadAbonos} type='number' id="standard-basic" style={{ 'width': '100%' }} label="Cantidad Abonos" variant="standard" />
                                </div>



                                <div className='col-md-6 mb-3'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker value={fechaPrestamo} label='Fecha Prestamo' variant='standard' onChange={(value) => setFechaPrestamo(value)} />
                                    </LocalizationProvider>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker value={fechaPrimerPago} label='Fecha Primer Pago' variant='standard' onChange={(value) => setPrimerPago(value)} />
                                    </LocalizationProvider>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <TextField onChange={(e) => setIntereses(e.target.value)} value={intereses} defaultValue={10} type='number' id="standard-basic" style={{ 'width': '100%' }} label="Interes" variant="standard" />
                                </div>

                                <div className='col-md-12 d-flex justify-content-center'>
                                    <Button disabled={spRA} onClick={enviarFormulario} size="small" className="mt-3" variant="contained" style={{ 'width': '75%' }}>
                                        Guardar
                                        {spRA && <div className="spinner-border spinner-border-sm" role="status" id='spisLoad'>
                                            <span className="sr-only"></span>
                                        </div>}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

        </div>
    )

}

export default RegistrarPrestamo